
class DataPoint {
  constructor(date, value) {
    this.date = date;
    this.value = value;
  }

  static of(date, value) {
    return new DataPoint(date, value);
  }

  toTYFormat() {
    return { t: this.date, y: this.value };
  }
}

export default DataPoint;
